import React from 'react'
import styled from 'styled-components'
import Spacer from '../../lib/spacer'
import Dashboard from './dashboard'
import InfoBoxes from './info_boxes'
import Download_buttons from '../../common/download_buttons'
import StoreLinks from '../../common/store_links'
import { useTranslation } from '../../lib/i18n'

const Wrapper = styled.div``

export default () => {
    const { t } = useTranslation(undefined, { keyPrefix: 'home.product' })

    return (
        <Wrapper>
            <Spacer size={150} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={70} className="show-for-small-only" />
            <div className="main grid-container">
                <div className="grid-x">
                    <div className="cell medium-12 text-center">
                        <h2 className="h1">
                            {t('titleLine1')} <br/> {t('titleLine2')}
                        </h2>
                        <Spacer size={30} />
                        <div className="grid-x align-center">
                            <div className="cell medium-8 text-center">
                                <p className="lead">{t('lead')}</p>
                            </div>
                        </div>
                        <Spacer size={30} />
                        <div className="grid-x align-center">
                            <StoreLinks />
                        </div>
                    </div>
                </div>
                <Spacer size={100} className="show-for-large" />
                <Spacer size={20} className="show-for-medium-only" />
                <Spacer size={50} className="show-for-small-only" />
                <Dashboard />
                <Spacer size={130} className="hide-for-large" />
                <Spacer size={180} className="show-for-large" />
                <InfoBoxes />
            </div>
            <Spacer size={150} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={70} className="show-for-small-only" />
        </Wrapper>
    )
}
